import { fetcher } from "helpers/fetcher";

import { TUpdateTicketReq, TUpdateTicketRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateTicket = async (payload: TUpdateTicketReq) => {
  return await fetcher<TUpdateTicketRes, TUpdateTicketReq["data"]>(
    ENDPOINT.MANAGEMENT.UPDATE_TICKET,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.UPDATE_TICKET.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
      urlData: {
        pipelineSlug: payload.pipelineSlug,
        idTicket: payload.idTicket,
      },
    }
  );
};

export const mutationUpdateTicket = async (payload: TUpdateTicketReq) => {
  return (await updateTicket(payload)).data.message;
};

mutationUpdateTicket._key = (payload: TUpdateTicketReq) => [
  ENDPOINT.MANAGEMENT.UPDATE_TICKET.url,
  payload,
];
